import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useRegistry } from '../../store/RegistryStore';
import { useTenantScope } from '../../store/selectors';
import { useToast } from '../../ui/feedback';

const SOURCES = [
  'Registry Direct',
  'Automic',
  'Boardroom',
  'MUFG Corporate Markets',
  'Generic spreadsheet',
];

export default function NewMigrationDialog({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const scope = useTenantScope();
  const { dispatch } = useRegistry();
  const toast = useToast();
  const [fundId, setFundId] = useState(scope.funds[0]?.id ?? '');
  const [source, setSource] = useState(SOURCES[0]);
  const [fileName, setFileName] = useState('');
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>Import a register</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            select
            label="Fund"
            value={fundId}
            onChange={(event) => setFundId(event.target.value)}
          >
            {scope.funds.map((fund) => (
              <MenuItem key={fund.id} value={fund.id}>
                {fund.code} · {fund.name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            label="Source registry"
            value={source}
            onChange={(event) => setSource(event.target.value)}
          >
            {SOURCES.map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </TextField>
          <Box
            component="label"
            sx={{
              border: '2px dashed',
              borderColor: 'divider',
              borderRadius: 2,
              p: 3,
              textAlign: 'center',
              cursor: 'pointer',
              '&:hover': { borderColor: 'primary.main' },
            }}
          >
            <input
              type="file"
              hidden
              accept=".csv,.xlsx"
              onChange={(event) => setFileName(event.target.files?.[0]?.name ?? '')}
            />
            <CloudUploadOutlinedIcon color="action" />
            <Typography variant="body2" sx={{ mt: 1 }}>
              {fileName || 'Choose a holder extract (CSV or Excel)'}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              The file is not uploaded anywhere in this prototype.
            </Typography>
          </Box>
          <Button
            size="small"
            onClick={() =>
              setFileName(`${source.split(' ')[0].toLowerCase()}_register_extract.csv`)
            }
          >
            Use a sample file
          </Button>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          disabled={!fileName || !fundId}
          onClick={() => {
            dispatch({ type: 'MIGRATION_CREATE', fundId, source, fileName, rows: 42 });
            toast('File uploaded. Confirm the column mapping next.');
            setFileName('');
            onClose();
          }}
        >
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
}
